import { useHistory, useLocation } from 'react-router-dom';
import StylesContext from '../context/StylesContext';
import { useContext } from 'react';
import VideoContext from '../context/VideoContext';
import VocalInterfaceContext from '../context/VocalInterfaceContext';

const useMediaEnd = () => {
  const { pathname } = useLocation();
  const { styles } = useContext(StylesContext);
  const { setIsVideo } = useContext(VideoContext);
  const { isVocalInterface } = useContext(VocalInterfaceContext);

  const history = useHistory();

  // isVocalInterface recbe true se o user clicar no botão de AD na tela de home
  const endMedia = () => {
    if(!pathname.includes('categories')) {
      const nextPage = isVocalInterface ? 'categoriesvocal' : 'categories';
      
      setTimeout(() => {
        setIsVideo(false);
        history.push(`/cardapio/${styles.urlId}/${nextPage}`);
      },2000);
    } else {
      setIsVideo(false);
    }
  };
  return endMedia;
}

export default useMediaEnd;